
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { AuthProvider } from './hooks/auth'
import { BrowserRouter } from 'react-router-dom'

// Handler global para erros não capturados - ignora AbortErrors silenciosamente
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason;
  // Ignorar silenciosamente AbortErrors (são esperados quando requisições são canceladas)
  if (error?.name === 'AbortError' || error?.message?.includes('aborted') || error?.message?.includes('signal is aborted')) {
    event.preventDefault(); // Previne que o erro apareça no console
    return;
  }
  // Logar outros erros para debug (apenas em desenvolvimento)
  if (import.meta.env.DEV) {
    console.error('[Unhandled Rejection]', error);
  }
});

// Handler para erros síncronos não capturados
window.addEventListener('error', (event) => {
  const error = event.error;
  // Ignorar silenciosamente AbortErrors
  if (error?.name === 'AbortError' || error?.message?.includes('aborted') || error?.message?.includes('signal is aborted')) {
    event.preventDefault();
    return;
  }
  // Logar outros erros para debug (apenas em desenvolvimento)
  if (import.meta.env.DEV) {
    console.error('[Unhandled Error]', error);
  }
});

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);
